import { dateArrayToZonedDate, SERVER_TIME_ZONE } from '../../shared/date-utils';
import { LastAssessment } from './last-assessment';
import { AssessmentCompletedAt, LastAssessmentDto } from './last-assessment-dto';

export function toLastAssessment(dto: LastAssessmentDto | null | undefined): LastAssessment | null {
  const assessment = dto && dto.assessment;
  if (!assessment) {
    return null;
  }

  return {
    passed: typeof assessment.passed === 'boolean' ? assessment.passed : null,
    completedAt: parseCompletedAt(
      assessment.completedDateTime != null ? assessment.completedDateTime : assessment.completedDate
    ),
  };
}

function parseCompletedAt(value: AssessmentCompletedAt | undefined): Date | null {
  if (value == null) {
    return null;
  }
  if (Array.isArray(value)) {
    return dateArrayToZonedDate(value, SERVER_TIME_ZONE);
  }

  const millis = typeof value === 'number' ? value : Date.parse(value);
  return isNaN(millis) ? null : new Date(millis);
}



// WEBPACK FOOTER //
// ./ts/app/home/lesson-carousel/last-assessment.helpers.ts